import { Link } from 'react-router-dom';

const guides = [
  {
    id: 'shoes-guide',
    title: 'Shoes Buying Guide',
    subtitle: 'Sneakers to dress shoes',
    bgColor: 'bg-accent-100',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20detail%20shot%20of%20premium%20leather%20sneakers%20with%20visible%20stitching%20and%20texture%20on%20rich%20walnut%20wood%20surface%20macro%20photography%20style%20dramatic%20shallow%20depth%20of%20field%20warm%20amber%20lighting%20editorial%20luxury%20aesthetic&width=500&height=500&seq=kakobuy-guide-shoes-v2&orientation=squarish',
  },
  {
    id: 'bags-guide',
    title: 'Bags Comparison',
    subtitle: 'Totes, backpacks & more',
    bgColor: 'bg-secondary-100',
    image: 'https://readdy.ai/api/search-image?query=Two%20designer%20handbags%20one%20leather%20tote%20and%20one%20canvas%20backpack%20placed%20on%20soft%20dusty%20blue%20matte%20surface%20gentle%20daylight%20from%20above%20editorial%20product%20comparison%20photography%20clean%20balanced%20composition%20refined%20aesthetic&width=500&height=500&seq=kakobuy-guide-bags-v2&orientation=squarish',
  },
  {
    id: 'accessories-guide',
    title: 'Accessories Guide',
    subtitle: 'Watches, jewelry, sunglasses',
    bgColor: 'bg-primary-100',
    image: 'https://readdy.ai/api/search-image?query=Delicate%20gold%20watch%20and%20minimalist%20jewelry%20pieces%20scattered%20on%20soft%20peach%20silk%20fabric%20surface%20warm%20golden%20hour%20backlight%20editorial%20product%20photography%20romantic%20luxurious%20aesthetic%20with%20gentle%20sparkle&width=500&height=500&seq=kakobuy-guide-accessories-v2&orientation=squarish',
  },
  {
    id: 'clothing-guide',
    title: 'Clothing Style Guide',
    subtitle: 'Streetwear & essentials',
    bgColor: 'bg-foreground-100',
    image: 'https://readdy.ai/api/search-image?query=Artfully%20draped%20hoodie%20and%20t-shirt%20layered%20on%20industrial%20metal%20rack%20against%20exposed%20brick%20wall%20background%20urban%20loft%20lighting%20editorial%20streetwear%20fashion%20photography%20cool%20contemporary%20grunge%20aesthetic&width=500&height=500&seq=kakobuy-guide-clothing-v2&orientation=squarish',
  },
];

export default function BuyingGuidesSection() {
  return (
    <section id="guides" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Buying Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Best <span className="text-primary-600">Kakobuy</span>
          </h2>
          <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 italic">
            Spreadsheet Guides
          </p>
          <p className="text-sm text-foreground-500 mt-4 max-w-lg leading-relaxed">
            Dive deep into category-specific <strong>kakobuy spreadsheet</strong> buying guides. Each guide covers pricing trends, seller ratings, and insider tips to help you shop smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guides.map((guide) => (
            <Link
              key={guide.id}
              to="/kakobuy-spreadsheet-beginners-guide"
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className={`w-full aspect-square overflow-hidden ${guide.bgColor}`}>
                <img
                  src={guide.image}
                  alt={guide.title}
                  title={`${guide.title} - Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top mix-blend-multiply transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-900">{guide.title}</h3>
                <p className="text-xs text-foreground-500 mt-1 flex items-center gap-1">
                  {guide.subtitle}
                  <span className="text-primary-500">Read more &rarr;</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}